import { AppContextMenu } from '@/UI/AppContextMenu/AppContextMenu';
import { usePromptEditorMenuItems } from './hooks/usePromptEditorMenuItems';
import type { AvailableInput, PromptEditorContextMenuState } from './types';
import type { Dispatch, SetStateAction } from 'react';
import type { Editor } from '@tiptap/react';
import type { PromptDisplayMode } from 'web';

interface PromptEditorContextMenuProps {
  editor: Editor;
  availableInputs: AvailableInput[];
  displayMode: PromptDisplayMode;
  contextMenu: PromptEditorContextMenuState;
  setContextMenu: Dispatch<SetStateAction<PromptEditorContextMenuState>>;
  addInputHandle: () => AvailableInput;
  onCreatePrompt: (queryText: string) => AvailableInput | undefined;
}

export const PromptEditorContextMenu = ({
  editor,
  availableInputs,
  displayMode,
  contextMenu,
  setContextMenu,
  addInputHandle,
  onCreatePrompt,
}: PromptEditorContextMenuProps) => {
  const { isOpen, menuItems, children, handleKeyDown, closeContextMenu } = usePromptEditorMenuItems({
    editor,
    availableInputs,
    displayMode,
    contextMenu,
    setContextMenu,
    addInputHandle,
    onCreatePrompt,
  });

  const isMentionMenu = contextMenu.type === 'mention';

  return (
    <AppContextMenu
      open={isOpen}
      onClose={closeContextMenu}
      onKeyDown={handleKeyDown}
      mouseX={contextMenu.x}
      mouseY={contextMenu.y}
      items={menuItems}
      width={isMentionMenu ? '160px' : '140px'}
      maxHeight={isMentionMenu ? undefined : '160px'}
      disableAutoFocus={isMentionMenu}
    >
      {children}
    </AppContextMenu>
  );
};
